import React from "react";
import ReactPaginate from "react-paginate";
import Arrow from "assets/icons/arrow.svg?react";

import "./styles.sass";

type DesktopInvitePaginatorElementProps = {
  currentPage: number;
  lastPage: number;
  onClick: (selectedItem: { selected: number }) => void;
};

const DesktopInvitePaginatorElement: React.FC<
  DesktopInvitePaginatorElementProps
> = ({ currentPage, lastPage, onClick }) => {
  const safeCurrentPage = Math.min(currentPage, lastPage);

  const handlePageClick = (selectedItem: { selected: number }) => {
    onClick(selectedItem);
  };
  const isPrevDisabled = safeCurrentPage <= 1;
  const isNextDisabled = safeCurrentPage >= lastPage;

  return (
    <div className="pagination-wrapper">
      <ReactPaginate
        previousLabel={null}
        nextLabel={null}
        pageCount={lastPage}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        forcePage={currentPage - 1}
        containerClassName="pagination"
        activeLinkClassName="active"
        breakLabel="..."
        breakLinkClassName="break"
        pageClassName="page-item"
        pageLinkClassName="page-link"
      />
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,react/button-has-type */}
      <button
        onClick={() =>
          !isPrevDisabled && handlePageClick({ selected: safeCurrentPage - 2 })
        }
        className="pagination-link__prev"
      >
        <Arrow
          className={`pagination-arrow ${isPrevDisabled ? "pagination-arrow_disabled" : ""}`}
        />
      </button>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label,react/button-has-type */}
      <button
        onClick={() =>
          !isNextDisabled && handlePageClick({ selected: safeCurrentPage })
        }
        className="pagination-link__next"
      >
        <Arrow
          className={`pagination-arrow_next ${isNextDisabled ? "pagination-arrow_disabled" : ""}`}
        />
      </button>
    </div>
  );
};

export default DesktopInvitePaginatorElement;
